import { FormControl, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { IStandard } from "src/domain/entities"
import { FormikOnSubmit } from "src/utils/types"
import { IStandardUpdateFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	standard: IStandard
	handleSubmit: FormikOnSubmit<IStandardUpdateFormFields>
}

export const StandardUpdateDrawerFormView: FC<Props> = ({
	standard,
	handleSubmit,
	...rest
}) => (
	<Formik<IStandardUpdateFormFields>
		initialValues={{ name: standard.name, semester: standard.semester }}
		onSubmit={handleSubmit}
		enableReinitialize={true}
	>
		{({ values, isSubmitting, handleChange }) => (
			<DrawerForm
				size="sm"
				headerLabel="Update Standard"
				submitLabel="Save"
				isSubmitting={isSubmitting}
				{...rest}
			>
				<Stack maxWidth={"sm"} marginX={"auto"}>
					{/* Name */}
					<FormControl>
						<InputLabel label="Standard Name" />
						<Input
							name="name"
							placeholder="Name"
							maxLength={100}
							required
							autoFocus
							value={values.name}
							onChange={handleChange}
						/>
						<ErrorMessage component={ErrorMessageField} name="name" />
					</FormControl>
					{/* Semester */}
					<FormControl>
						<InputLabel label="Semester" />
						<Input
							name="semester"
							placeholder="Semester"
							maxLength={100}
							value={values.semester}
							onChange={handleChange}
						/>
						<ErrorMessage component={ErrorMessageField} name="semester" />
					</FormControl>
				</Stack>
			</DrawerForm>
		)}
	</Formik>
)
